export default "__VITE_ASSET__05eb003f__"